import { translate, useTranslate } from 'magner';
import { request } from '~/utils/request';

export const importResidentsFileUpload = (file: File) => {
  const { customT } = useTranslate();
  const errorMsg = customT(translate('hubstr.common.errors.file_upload'));

  const fileCreate = request.custom<File>(async ({ api, data, parseError }) => await api
    .instance
    .url('/api/admin/gaz/user/import')
    .formData({
      usersFile: data,
    })
    .post()
    .json((response) => {
      const d = (response as { data: { countImported: number } })?.data;
      return d?.countImported ? { data: d } : { error: errorMsg };
    })
    .catch((e) => ({
      error: JSON.parse(parseError(e).message).data?.msg || errorMsg,
    })) as any);

  return fileCreate(file);
};
